export const OPTHINES = {
  voteName: '2020project/2020calligraphy',
  number: {
    mustRank: true,
  },
  themeColor: {
    activeBgColor: '#E7BCE4',
    inactiveBgColor: '#C660BE',
  },
  tabs: [
    {
      tabName: '活动首页',
      tabPath: '/20200731ZJBTwo/First',
    },
    {
      tabName: '活动规则',
      tabPath: '/20200731ZJBTwo/Rules',
    },
    {
      tabName: '相关新闻',
      tabPath: '/20200731ZJBTwo/News',
    },
    {
      tabName: '我的作品',
      tabPath: '/20200731ZJBTwo/User',
    },
  ],
};
